import React from 'react';
import { ButtonIcon, ButtonStyled, } from './Button.styles';
const Button = ({ children, disabled, variant = 'primary', color, iconLeading, iconTrailing, title, ...props }) => {
    return (React.createElement(ButtonStyled, { variant: variant, disabled: disabled, ...props },
        iconLeading && React.createElement(ButtonIcon, { name: iconLeading }),
        children || title,
        iconTrailing && React.createElement(ButtonIcon, { name: iconTrailing })));
};
export default Button;
//# sourceMappingURL=Button.js.map